import { render, staticRenderFns } from "./RewardCollect.vue?vue&type=template&id=774536a6&scoped=true&"
import script from "./RewardCollect.vue?vue&type=script&lang=js&"
export * from "./RewardCollect.vue?vue&type=script&lang=js&"
import style0 from "./RewardCollect.vue?vue&type=style&index=0&id=774536a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774536a6",
  null
  
)

export default component.exports